import { t } from "@/lib/i18n";
import { useCountUp, useReveal } from "@/hooks/useReveal";

const Stat = ({ value, prefix = "", suffix = "", label, run, testId }) => {
  const n = useCountUp(value, run);
  return (
    <div data-testid={testId} className="border-l border-white/30 pl-5">
      <p className="font-mark text-4xl font-bold text-white sm:text-5xl">{prefix}{n}{suffix}</p>
      <p className="mt-2 text-xs font-semibold uppercase tracking-[0.16em] text-white/80">{label}</p>
    </div>
  );
};

export const ImpactBand = ({ count }) => {
  const [ref, inView] = useReveal();
  return (
    <section ref={ref} data-testid="impact-band" className="ac-grad relative overflow-hidden">
      <div className={`ac-reveal ${inView ? "is-in" : ""} relative mx-auto max-w-[1300px] px-4 py-20 sm:px-8 lg:py-28`}>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/80">{t("impact.kicker")}</p>
        <div className="mt-6 grid gap-8 text-lg leading-relaxed text-white md:grid-cols-2 md:gap-16 lg:text-xl">
          <p>{t("impact.p1")}</p>
          <p>{t("impact.p2")}</p>
        </div>
        <div className="mt-16 grid grid-cols-2 gap-8 lg:grid-cols-4">
          <Stat testId="stat-offices" value={count} prefix="+" label={t("stat.offices")} run={inView} />
          <Stat value={6} label={t("stat.cats")} run={inView} />
          <Stat value={3} label={t("stat.langs")} run={inView} />
          <Stat value={24} suffix="/7" label={t("stat.ai")} run={inView} />
        </div>
      </div>
    </section>
  );
};
